import {FC} from 'react'

export interface ContactSectionProps {
    
}

export const ContactSection: FC<ContactSectionProps> = (props) => {

    return(
        <>
            Contact
        </>
    )
}